import { CommonModule } from '@angular/common';
import { Component, computed, input, output } from '@angular/core';

export interface ButtonProps {
  isLoading?: boolean;
  isDisabled?: boolean;
  text?: string;
  variant?: 'primary' | 'outline';
  class?: string;
}

@Component({
  selector: 'app-fnf-buttons',
  imports: [CommonModule],
  templateUrl: './fnf-buttons.html',
  styleUrl: './fnf-buttons.scss',
})
export class FnfButtons {
  buttonProps = input<ButtonProps>({
    isLoading: false,
    isDisabled: false,
    text: 'Ok',
    variant: 'primary',
    class: '',
  });

  defaultProps: ButtonProps = {
    isLoading: false,
    isDisabled: false,
    text: 'Ok',
    variant: 'primary',
    class: '',
  };

  resolvedProps = computed(() => {
    return { ...this.defaultProps, ...this.buttonProps() };
  });

  onClick = output<void>();

  buttonClass = computed(() => {
    const props = this.buttonProps();

    const variantClass = props.variant === 'outline' ? 'fnf-outline-button' : 'fnf-primary-button';

    return `${variantClass} ${props.class ?? ''}`.trim();
  });

  click() {
    this.onClick.emit();
  }
}
